import type { BenefitSummary } from "@yutai/shared"

// 優待の段階（tier）ごとの 株数/優待金額。クロールで取れた金額より、管理者が手入力した金額を優先する。

export interface BenefitOption {
  shares: number
  /** 実際に損益計算へ使う金額（手入力があればそれ、無ければクロール値）。どちらも無ければ null */
  value: number | null
  crawledValue: number | null
  overridden: boolean
}

/** 手入力の優待金額: 最低株数（文字列キー）→ 円 */
export type BenefitValueOverrides = Record<string, number>

/** tier が無い（または最低株数が tier に無い）場合は、最低株数・最低優待金額の1件を補う */
export function benefitOptions(
  benefit: BenefitSummary,
  overrides?: BenefitValueOverrides
): BenefitOption[] {
  const crawled = new Map<number, number | null>()
  for (const t of benefit.tiers ?? []) crawled.set(t.minimumShares, t.benefitValue ?? null)
  if (!crawled.has(benefit.minimumShares)) {
    crawled.set(benefit.minimumShares, benefit.minimumBenefitValue ?? null)
  }
  return [...crawled]
    .sort(([a], [b]) => a - b)
    .map(([shares, crawledValue]) => {
      const override = overrides?.[String(shares)]
      const overridden = override !== undefined
      return {
        shares,
        value: overridden ? override : crawledValue,
        crawledValue,
        overridden,
      }
    })
}
